(() => {
  if (customElements.get('sbf-ad-video')) return;
  customElements.define('sbf-ad-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const button = this.querySelector('[data-ad-video-play]');
      const template = this.querySelector('[data-ad-video-template]');
      if (!button || !template) return;
      this.ready = true;
      button.hidden = false;
      button.addEventListener('click', () => {
        if (this.loaded) return;
        const fragment = template.content.cloneNode(true);
        const video = fragment.querySelector('video');
        if (!video) return;
        this.loaded = true;
        this.querySelector('.ad-video__cover')?.remove();
        this.append(fragment);
        template.remove();
        video.focus({ preventScroll: true });
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      });
    }
  });
})();
